import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _SearchLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("circle", { cx: 11, cy: 11, r: 6, stroke: "currentColor" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "m20 20-3-3" })));
}
const SearchLight = forwardRef(_SearchLight);
export { SearchLight };
